import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Mistakes } from './components/Mistakes';
import { Mechanism } from './components/Mechanism';
import { Details } from './components/Details';
import { Offer } from './components/Offer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    window.fbq('init', '1596283211482504');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-red selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Mistakes data-id="element-3" />
      <Mechanism data-id="element-4" />
      <Details data-id="element-5" />
      <Offer data-id="element-6" />

      <footer className="bg-[#050508] py-8 text-center border-t border-white/5" data-id="element-7">
        <p className="text-brand-gray text-sm" data-id="element-8">
          © {new Date().getFullYear()} El Código del Visto. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}
export { App };